type RedditPixel = ((...args: unknown[]) => void) & { callQueue: unknown[][]; sendEvent?: (...args: unknown[]) => void };
let loaded = false;
export const landingPixelLoaded = () => loaded;
/** This SDK is allowed only in the public landing document. Navigation must unload it. */
export function loadLandingPixel(pixelId: string) {
  if (loaded || !/^a2_[a-z0-9]+$/.test(pixelId) || window.location.pathname !== '/') return;
  loaded = true;
  const target = window as Window & { rdt?: RedditPixel };
  const rdt: RedditPixel = Object.assign((...args: unknown[]) => {
    if (rdt.sendEvent) rdt.sendEvent(...args); else rdt.callQueue.push(args);
  }, { callQueue: [] as unknown[][] });
  target.rdt = rdt;
  rdt('init', pixelId);
  rdt('track', 'PageVisit');
  const script = document.createElement('script');
  script.src = `https://www.redditstatic.com/ads/pixel.js?pixel_id=${pixelId}`;
  script.async = true;
  document.head.appendChild(script);
}
